import {Component, Input, OnInit} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {LANG, LocalStorageService} from "@services";

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit {
  activeLang?: string;
  isDropdownOpen: boolean = false;
  @Input() isLanding: boolean = false;

  constructor(private translocoService: TranslocoService, private localStorageService: LocalStorageService) {
  }

  ngOnInit(): void {
    this.activeLang = this.translocoService.getActiveLang();
  }

  changeLang(lang: string): void {
    this.translocoService.setActiveLang(lang);
    this.activeLang = lang;
    this.localStorageService.saveData(LANG, lang);
  }

  checkDropDown(event: boolean) {
    this.isDropdownOpen = event;
  }
}
